module.exports = {
  highLightMenu: function(currentPageId) {
    // 사이드바 액티브 컨트롤
    //////////////////////////////////////////////////////////////////////////////
    document.getElementById('mainCustomId8642').className
    = document.getElementById('mainCustomId8642').className.replace("active", "");
    document.getElementById('budgetCustomId8642').className
    = document.getElementById('budgetCustomId8642').className.replace("active", "");
    document.getElementById('reachCustomId8642').className
    = document.getElementById('reachCustomId8642').className.replace("active", "");
    document.getElementById('reachDACustomId8642').className
    = document.getElementById('reachDACustomId8642').className.replace("active", "");
    document.getElementById('systemInfoCustomId8642').className
    = document.getElementById('systemInfoCustomId8642').className.replace("active", "");
    document.getElementById('reachCurveCustomId8642').className
    = document.getElementById('reachCurveCustomId8642').className.replace("active", "");
    document.getElementById('modelCustomId8642').className
    = document.getElementById('modelCustomId8642').className.replace("active", "");
    ///////////////////////////////////////////////////////////////////////////////
    document.getElementById(currentPageId).className += " active";
    // 사이드바 액티브 컨트롤

  }
}



// WEBPACK FOOTER //
// ./src/views/common/LeftSideUtil.js